query DocumentDownloadLink($documentId: UUID!, $userRequested: Boolean) {
  entityDocument(id: $documentId) {
    id
    _downloadLink(userRequested: $userRequested)
  }
}
